import React from 'react';
import PropTypes from 'prop-types';
import QuestionCircleIcon from 'adp-react-icons/lib/fa/question-circle';
import {
  Button,
  Textbox,
  Alert,
  Popover,
  OverlayTrigger
} from 'adp-react-components';
import GlobalPasswordIndicator from './../../../components/utils/global-password-indicator.js';

function isValidPassword(password) {
  return password != '';
}
class CreatePassword extends React.Component {
  constructor(props) {
    console.log('constructor initialized for create-password');
    super(props);
    this.state = {
      newPassword: '',
      confirmPassword: ''
    };
  }
  componentWillMount() {
    console.log('componentWillMount initialized for create-password');
    this.setState({
      newPassword: '',
      confirmPassword: ''
    });
  }
  handleKeyPress(e) {
    if(isValidPassword(this.state.confirmPassword)){
    if (e.charCode == 13) {
      e.preventDefault(); //preventing html5 default form submit
      this.onSubmit();
    }
  }
  }
  onNewPasswordEntered(value) {
    this.setState({
      newPassword: value,
      confirmPassword: ''
    });
    this.props.showErrorMessage('', 'error');
  }

  onConfirmPasswordEntered(value) {
    this.setState({
      confirmPassword: value
    });
    this.props.showErrorMessage('', 'error');
  }
  onSubmit(event) {
    gtag('event', 'Enroll|CreatePWD|Click', {
      'event_category': 'Admin Login',
      'event_label': 'Create Password'
    });
    fetch(context+'/enroll/adpPassword.faces?enrollNewPasswordForm=', {
      method: 'POST',
      //same-origin is needed to keep the cookies
      credentials: 'same-origin',

      headers: {
        Accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body:
        'enrollNewPasswordForm=enrollNewPasswordForm&enrollNewPasswordForm:password=' +
        encodeURIComponent(this.state.newPassword) +
        '&enrollNewPasswordForm:cPassword=' +
        encodeURIComponent(this.state.confirmPassword) +
        '&enrollNewPasswordForm:submitButton=&javax.faces.ViewState=' +
        Tier0.get('javax.faces.ViewState').value
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          this.props.showErrorMessage((this.decodeHtmlEntity(data.wizard.message)).split('?').join('\''), 'error');
          return;
        }
        {
          this.props.deliverypageexist
            ? this.props.showDeliveryMethod()
            : this.props.showVerificationCode();
        }
      });
  }
  // encode(decode) html text into html entity
  decodeHtmlEntity(str) {
    return str.replace(/&#(\d+);/g, function(match, dec) {
      return String.fromCharCode(dec);
    });
  }
  
  onHasErrorChange(value) {
    this.setState({
      hasError: value
    });
  }

  render() {
    let isValid = isValidPassword(this.state.confirmPassword,this.state.newPassword);
    var styles = {};

    const popover = (
      <Popover
        id="popover-1"
        placement="top"
        title=""
        className="vdl-custom-popover-content">
        {this.props.passwordStrengthHelperText}
      </Popover>
    );

    return (
      <div className="vdl-row login-form">
        <div className="vdl-col-md-12">
          <form className="adp-form">
            <div className="form-group user-id">
              <div className="vdl-row">
                <div className="vdl-col-sm-6 vdl-col-xs-12">
                  <label htmlFor="password">
                    {this.props.createPasswordLable}{' '}
                  </label>
                  <span className="password-helper">
                    <OverlayTrigger
                      trigger="click"
                      placement="top"
                      overlay={popover}>
                      <QuestionCircleIcon />
                    </OverlayTrigger>
                  </span>
                </div>
              </div>

              <div className="input-group-full">
                <GlobalPasswordIndicator
                  styles={styles}
                  passwordCallBackFun={this.onNewPasswordEntered.bind(this)}
                  isPasswordCallBackRequired="yes"
                  position="right"
                  textBoxId="newPssword"
                  passwordStrengthIndLetterLabel={
                    this.props.passwordStrengthIndLetter
                  }
                  passwordStrengthIndNumberLabel={
                    this.props.passwordStrengthIndNumber
                  }
                  passwordStrengthIndCharsLabel={
                    this.props.passwordStrengthIndChars
                  }
                />
                {/*
                              <Textbox
                                value={ this.state.newPassword }
                                type="password"
                                  onChange={ this.onNewPasswordEntered.bind(this) }>
                              </Textbox>
                              */}
              </div>
              {/* input-group-full */}
            </div>
            {/* form-group  */}
            <div className="form-group ">
              {/*  <PasswordStrengthIndicator strength={this.state.pwdStrength}/>  */}
            </div>

            <div className="form-group password">
              <label htmlFor="confirmPassword">
                {this.props.confirmPasswordLabel}
              </label>
              <div className="input-group-full">
                <Textbox
                  value={this.state.confirmPassword}
                  type="password"
                  onChange={this.onConfirmPasswordEntered.bind(this)}
                  onKeyPress={this.handleKeyPress.bind(this)}
                />
              </div>
              {/* input-group-full */}
            </div>

            {/* form-group password */}
            <div className="form-group submit vdl-text-xs-center">
              <Button
                className="primary"
                disabled={!isValid}
                onClick={this.onSubmit.bind(this)}>
                {this.props.submit}
              </Button>
            </div>
            {/* form-group submit vdl-text-xs-center */}
          </form>
          {/* adp-form */}
        </div>
        {/* vdl-col-md-12 */}
      </div>
    );
  }
}
CreatePassword.propTypes = {
  newPassword: PropTypes.string,
  passwordLabel: PropTypes.string,
  submit: PropTypes.string,
  confirmPassword: PropTypes.string
};

CreatePassword.getDefaultProps = {
  newPassword: undefined,
  passwordLabel: undefined,
  submit: undefined,
  confirmPassword: undefined
};

export default CreatePassword;



// WEBPACK FOOTER //
// ./src/scenes/admin-login/enroll/create-password.js